import { Route } from "../Models/Route";

export const clientRoutes: Route[] = [
    {path: "/panel", icon: <> </> , navbarShow: false, regex:null},


    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]

export const adminRoutes: Route[] = [
    {path: "/panel", icon: <> </> , navbarShow: false, regex:null},


    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]

export const nonRoutes: Route[] = [
    {path: "/productos", icon: <> </> , navbarShow: false, regex:null},
    {path: "/proximamente", icon: <> </> , navbarShow: false, regex:null},
    {path: "/cartas", icon: <> </> , navbarShow: false, regex:null},
    {path: "/login", icon: <> </> , navbarShow: false, regex:null},


    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]